import React, { Component } from 'react'; 
import {InputGroup, FormControl, Table, Button, Pagination} from 'react-bootstrap';
import SamplingLogic from './SamplingLogic';
import ViewModeSampling from './viewModeSampling';
import _ from 'lodash';
function searchingFor(term){
	return function(x){
		return _.includes(x.templateTitle.toLowerCase(), term.toLowerCase()) || !term;
	}
}
export default class SamplingElements extends Component {
  constructor(props){
    super(props)
    this.state= {
			term:'',
			activePage: 1
    }
	}
	componentDidMount(){
	this.props.action.TokenValidation()     
	this.props.action.SampleTemplate() 
	this.props.action.actioninventoryMaster()
	}
	
	handleChange = (e) => {
		this.setState({term:e.target.value})	
	}
	openModal =() => {
		this.setState({ modalIsVisible: true, });
	}
	
	closeModal=() =>{
		this.setState({ modalIsVisible: false, });
	}
	openModalEdit =(i) => {
		this.setState({['modalIsVisibleEdit'+i]: true, });
	}
	
	closeModalEdit=(i) =>{
		this.setState({['modalIsVisibleEdit'+i]: false, });
	}
	openModalView =(i) => {
		this.setState({['modalIsRead'+i]: true, });
	}
	
	closeModalView=(i) =>{
		this.setState({['modalIsRead'+i]: false, });
	}
	handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
	}	
	
	render(){
		const{templates, auditTypes, masterinventory, durationProp, defaultTemplate, action, accessPermission}= this.props;
		
		let permission  = _.includes(accessPermission,'WRITE')
		const{term, activePage} = this.state;
		const Per_Page=10;
		let totalPages;
		if(!_.isEmpty(templates)){
			totalPages = Math.ceil(templates.length/Per_Page)
		}		
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
		let items = [];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
		}
    return(
					<div>
					<span className='alignRight'>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
				</InputGroup>
				</span>  
				{!_.isEmpty(defaultTemplate) ?
    		<Button onClick={this.openModal} className='buttonwidth alignRight'>New Sampling</Button> : null}
					 {this.state.modalIsVisible ? 
					<SamplingLogic  closeModal={this.closeModal} 
					action={action}
					templates={defaultTemplate} 
					masterinventory={!_.isEmpty(masterinventory) ? masterinventory.categories : []}
					fullTemplate={templates}
					auditTypes={auditTypes}
					durationProp={durationProp} /> : null}				 
				 <div>
				<Table responsive>
					<thead>
							<tr>
								<th>SAMPLING CRITERIA</th>				
								{(permission === true) ? <th>EDIT</th> : null}
								<th>VIEW</th>
							</tr>
					</thead>
          <tbody>
					{
						(!_.isEmpty(templates)) ?
            _.map(templates.filter(searchingFor(term)), (val, i)=>{
							if(i >= startOffset & startCount < Per_Page){
								startCount++;
					return(
            <tr><td>{val.templateTitle}</td>
           {(permission === true) ?  <td><i class="fas fa-pen" onClick={() => this.openModalEdit(i)} />
            {this.state['modalIsVisibleEdit'+i] ? 
             	<SamplingLogic  closeModal={()=>this.closeModalEdit(i)} 
							 action={action} edit={true}
							 templates={_.find(templates,{'id':val.id})} 
							 fullTemplate={templates}
							 masterinventory={!_.isEmpty(masterinventory) ? masterinventory.categories : []}
							 auditTypes={auditTypes}
							 durationProp={durationProp} /> 
             : null }
            </td> : null}
						<td><i class='fas fa-eye' onClick={()=>this.openModalView(i)}/>
						{this.state['modalIsRead'+i] ?
						<ViewModeSampling closeModal={()=>this.closeModalView(i)} auditTypes={auditTypes}  data={val}/> : null}
						</td>
						</tr>	
					)
						 } })

					: <tr><td colSpan='3'>No Records Found</td></tr>

           } 
          </tbody>
          </Table>
					<Pagination>
					<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
					<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
						{items[0]}
						{(activePage !== 1)  ? items[activePage-1] : null}
						{(activePage !== totalPages)  ?   items[totalPages-1]   : null }
					<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
					<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
					</Pagination>
					</div>
    </div>
		);
	}
}
   

  